//import Swal from "sweetalert2";
//import Vue from "vue";
import { changePaymentModel, getUser } from '@/services/modules/user'

export const state = {
  user: {}
}

export const mutations = {
  setUser (state, data) {
    state.user = data
  }
}

export const getters = {
  getUser (state) {
    return state.user
  }
}

export const actions = {
  async getRestaurant (context, { payload }) {
    const result = await getUser(payload)
    if (result.data.status) {
      context.commit('setUser', result.data.data)
    }
  },
  async changePaymentModel (context, { payload }) {
    const result = await changePaymentModel(payload)
    if (result.data.status) {
      context.dispatch('getRestaurant', {payload: {restaurantId: payload.restaurantId}})
    }
  }
}
